var ModalLocation;
(function (ModalLocation) {
    ModalLocation["Homepage"] = "Homepage";
    ModalLocation["MyLinkedCards"] = "MyLinkedCards";
    ModalLocation["DealImportantInfo"] = "DealImportantInfo";
})(ModalLocation || (ModalLocation = {}));
export default ModalLocation;
